import React from 'react';
import PropTypes from 'prop-types';

import DateTime from "components/Display/ViewDateTime";

const ActionHistoryTag = ({ item }) => {

  let backgroundStyle = {    
    borderColor : '#125d08'
    // borderColor : '#ffffff'
  };

  switch (item.step){
    case 1:
      backgroundStyle.borderColor = '#7a7879';
      break;
    case 2:
      backgroundStyle.borderColor = '#2e6300';
      break;
    case 3:
      backgroundStyle.borderColor = '#9c9c06';
      break;
    case 4:
      backgroundStyle.borderColor = '#826a00';
      break;
    case 5:
      backgroundStyle.borderColor = '#983900';
      break;
    case 6:
      backgroundStyle.borderColor = '#004a64';
      break;
    default:
    
    break;
  }

  if (item.flag && item.step === 6){
    backgroundStyle.borderColor = '#520182'
  }
  else if (item.flag){
    backgroundStyle.borderColor = '#820005'
  }

  return (
    <div className="actionhistory-div-inline">
      <span className="actionhistory-info-tag" style={backgroundStyle}> <DateTime data={item.actionDate}/> - {item.action} {item.byUserName && '('+item.byUserName+')'}</span>
    </div>
  );
};

ActionHistoryTag.propTypes = {
  item : PropTypes.object,
};

export default ActionHistoryTag;



// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Tags/ActionHistoryTag.js